<div *ngIf="otpDesign === OLD_DESIGN" [ngSwitch]="currentStepIndex" class="modal">
	<div *ngSwitchCase="0">
		<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" nz-row>

			<div nz-col nzSpan="18">
				<div>
					<div class="title">
						<div>{{'moniepoint.enter'|translate}} OTP</div>
					</div>
					<div class="sub-title">
						<p>
							{{otpResponse?.message}}</p>
					</div>

					<div *ngIf="otpResponse.ussdCode" class="sub-title m-b-10">
						<span class="m-t-9">or dial <a href="{{'tel:' + otpResponse?.ussdCode}}"><span
									class="fa fa-phone"></span>{{otpResponse?.ussdCode}}</a></span>
						<!--              <p class="m-t-9">-->
						<!--                {{'or dial'}}{{" "}}{{otpResponse?.ussdCode}}</p>-->
					</div>

				</div>
			</div>

			<div nz-col nzSpan="24">
				<form [formGroup]="otpForm" autocomplete="off" nz-form>
					<nz-form-item>
						<nz-form-control nzErrorTip="Enter valid OTP">
							<nz-input-group class="custom-modal-body-content-spacing">
								<input formControlName="otp" maxlength="6" nz-input
									placeholder="{{'moniepoint.enter'|translate}} OTP" type="text" />
							</nz-input-group>
						</nz-form-control>
					</nz-form-item>
				</form>
			</div>

			<div *ngIf="countDown" nz-col nzSpan="24">
				<div nz-row>
					<div nz-col nzSpan="8">
						<div class="otp-countdown-container">
							<h6 class="otp-countdown" translate>moniepoint.time_remaining</h6>
						</div>
					</div>
					<div nz-col nzSpan="12">
						<div class="otp-countdown-container">
							<nz-countdown [nzFormat]="'mm:ss'"
								[nzValueStyle]="{lineHeight: '15px',fontSize:'14px',color:'#0361F0'}"
								[nzValue]="deadline"></nz-countdown>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="!countDown" nz-col nzSpan="24">
				<div align="right">
					<div class="otp-resend">
						<a (click)="resendOtp()">{{'moniepoint.resend'|translate}} OTP</a>
					</div>
				</div>
			</div>

			<div nz-col nzSpan="24">
				<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
			</div>

			<div nz-col nzSpan="24">
				<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
					<div [nzSpan]="12" class="gutter-row" nz-col>
						<button (click)="cancel()" [disabled]="loadingButton"
							class="btn btn-secondary btn-block">{{'moniepoint.cancel'|translate}}</button>
					</div>

					<div [nzSpan]="12" class="gutter-row" nz-col>
						<app-custom-submit-button (submitForm)="submitOtp()" [block]="true" [disabled]="!otpForm.valid"
							[submitting]="loadingButton" name="Submit">
						</app-custom-submit-button>
					</div>
				</div>
			</div>

		</div>
	</div>

	<div *ngSwitchDefault>
		<app-loading [loadingText]="loadingText|translate"></app-loading>
	</div>

</div>

<div *ngIf="otpDesign === NEW_DESIGN" [ngSwitch]="currentStepIndex">

	<div *ngSwitchDefault>
		<app-loading [loadingText]="loadingText|translate"></app-loading>
	</div>

	<div *ngSwitchCase="5">
		<app-moniepoint-failure-modal (closeModal)="cancel()" [description]="errorMessage" [title]="responseMessage">
		</app-moniepoint-failure-modal>
	</div>

	<ng-container *ngSwitchCase="0">
		<div [style]="{padding:'0!important'}">

			<div>
				<h2>Device Registration</h2>
				<div>
					{{
					otpResponse?.message
					|| 'We’ve just sent you a 6 digit code. Check your messages and enter it here.'
					}}
				</div>
			</div>
			<form (ngSubmit)="submitOtp()" [formGroup]="otpForm" class="login-form" nz-form>
				<nz-form-item>
					<nz-form-control>
						<nz-input-group class="custom-modal-body-content-spacing">
							<input formControlName="otp" maxlength="6" nz-input
								placeholder="{{'moniepoint.enter'|translate}} OTP" type="password" />
						</nz-input-group>
						<ng-template #userPrefixTemplate>
							<svg fill="none" height="24" viewBox="0 0 24 24" width="24"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M14.9478 4.30902C14.1993 3.46487 13.1539 3 12.0001 3C10.8401 3 9.79121 3.46205 9.0462 4.30098C8.29312 5.14915 7.92619 6.30188 8.01235 7.54661C8.18312 10.0023 9.97198 12 12.0001 12C14.0282 12 15.814 10.0027 15.9874 7.54741C16.0747 6.31393 15.7055 5.16362 14.9478 4.30902Z"
									fill="#9BA6B9" />
								<path
									d="M18.769 20.9999H5.23096C5.05375 21.0024 4.87827 20.9621 4.71726 20.8818C4.55626 20.8016 4.41379 20.6835 4.30021 20.5361C4.05022 20.2124 3.94945 19.7703 4.02407 19.3232C4.34867 17.3724 5.36172 15.7337 6.95399 14.5833C8.36856 13.5621 10.1604 13 12 13C13.8396 13 15.6314 13.5625 17.046 14.5833C18.6383 15.7333 19.6513 17.372 19.9759 19.3228C20.0505 19.7699 19.9498 20.212 19.6998 20.5357C19.5863 20.6832 19.4438 20.8014 19.2828 20.8816C19.1218 20.9619 18.9463 21.0023 18.769 20.9999V20.9999Z"
									fill="#9BA6B9" />
							</svg>
						</ng-template>
					</nz-form-control>
				</nz-form-item>
				<nz-alert [nzMessage]="loanDesc" class="m-t-10 m-b-10" nzShowIcon nzType="info">
					<ng-template #loanDesc>
						Didn't get the code? dial <a
							[href]="'tel:'+otpResponse?.ussdCode"><strong>{{otpResponse?.ussdCode}}</strong></a>
					</ng-template>
				</nz-alert>

				<ng-container *ngIf="errorMessage">
					<app-custom-error-display [errorDescription]="errorMessage" [errorMessage]="'OTP Failed'">
					</app-custom-error-display>
				</ng-container>

				<div class="m-t-20" nz-row nzAlign="middle" nzJustify="space-between">
					<div>

					</div>
					<div nz-row nzAlign="middle">
						<div class="cta-secondary-link">
							<a (click)="cancel()">Cancel</a>
						</div>
						<div class="m-l-48">
							<div class="button-size-124">
								<app-custom-submit-button [block]="true" [disabled]="!otpForm.valid"
									[submitting]="loadingButton" name="{{'moniepoint.submit'|translate}}">
								</app-custom-submit-button>
							</div>
						</div>
					</div>
				</div>
			</form>

		</div>
	</ng-container>

</div>